import { useState } from 'react';

import 'react-dates/initialize';

import _ from 'lodash';

import ExpandLess from '@mui/icons-material/ExpandLess';

import Accordion from '@mui/material/Accordion';

import AccordionSummary from '@mui/material/AccordionSummary';

import AccordionDetails from '@mui/material/AccordionDetails';

import Router from 'next/router';

import moment from 'moment';

import PropTypes from 'prop-types';

import useResponsive from '../../../../utils/responsive';

import { Button } from '../../shared';

const BuildingDetailsCard = (props) => {
    
    const { isMobile, isTablet } = useResponsive();

    const [expanded, setExpanded] = useState(false);

    const {
        selectedBuilding,
        selectedBuildingRoomTypes,
        cities,
        selectedBuildingRoomTypesSummary,
    } = props;

    const id = _.get(selectedBuilding, 'id');

    const cityId = _.get(selectedBuilding, 'address.cityId');

    const city = _.find(cities, { id: cityId });

    const getCategories = () => {
        const uniqueCategories = _.uniq(
            _.map(
                selectedBuildingRoomTypes,
                (roomType) => `${_.trim(_.get(roomType, 'category'))}`,
            ),
        );

        return _.map(uniqueCategories, (category, index) => {
            return (
                <div className='building-details-card-category' key={index}>
                    <img
                        src={getImgSrc(category)}
                        alt="category-icon"
                        width={24}
                        height={24}
                        className='building-details-card-img'
                    />

                    <h6 className='building-details-card-normal'>{category}</h6>
                </div>
            );
        });
    };

    const getCategoriesMobile = () => {
        const uniqueCategories = _.uniq(
            _.map(
                selectedBuildingRoomTypes,
                (roomType) => `${_.trim(_.get(roomType, 'category'))}`,
            ),
        );

        return (
            <div className='building-details-card-category-mobile-container'>
                {_.map(uniqueCategories, (category) => {
                    return (
                        <div className='building-details-card-mobile-row'>
                            <div className='building-details-card-category-mobile'>
                                <img
                                    src={getImgSrc(category)}
                                    alt="category-icon"
                                    width={16}
                                    height={16}
                                    className='building-details-card-img'
                                />

                                <h6 className='building-details-card-normal'>{category}</h6>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    const getImgSrc = (category) => {
        let src = '/assets/images/unnamed.png';
        switch (_.lowerCase(category)) {
            case 'one bedroom':
                src = '/assets/images/green_one_bedroom.png';
                return src;
            case 'bachelor':
                src = '/assets/images/green_bachelor.png';
                return src;
            case 'private room':
            case 'private apartment':
            case 'private bedroom':
                src = '/assets/images/green_private_room.png';
                return src;
            case 'two bedroom':
                src = '/assets/images/green_two_bedroom.png';
                return src;
            case 'three bedroom':
                src = '/assets/images/green_three_bedroom.png';
                return src;
            case 'daily':
            case 'daily room':
                src = '/assets/images/green_daily.png';
                return src;
            case 'shared room':
            case 'co living':
                src = '/assets/images/green_shared_room.png';
                return src;
            default:
                return src;
        }
    };

    const getSoonestAvailable = () => {
        const sorted = _.sortBy(selectedBuildingRoomTypes, [
            (roomType) => roomType.soonestAvailable,
        ]);
        return moment(_.get(sorted[0], 'soonestAvailable')).format('DD MMMM');
    };

    const getLowestStartingPrice = () => {
        const sorted = _.sortBy(selectedBuildingRoomTypes, [(roomType) => roomType.startingPrice]);
        return `${_.get(sorted[0], 'startingPrice')} ${_.get(
            sorted[0],
            'billingModelDescription',
        )}`;
    };

    const getTotalAvailable = () => {
        var totalAvailable = _.reduce(
            selectedBuildingRoomTypesSummary,
            function (sum, n) {
                return sum + n.numberAvailable;
            },
            0,
        );
        return totalAvailable;
    };

    const handleExpansionChange = () => {
        setExpanded(!expanded);
    };

    const onFindaSpaceClick = async () => {
        Router.push(`/bookings?city=${_.get(city, 'name')}&building=${id}`).then(() =>
            window.scrollTo(0, 0),
        );
    };

    const onContinueClick = async () => {
        setExpanded(true);
    };

    const CardHeader = () => {
        const name = _.get(selectedBuilding, 'name');
        const addressLine1 = _.get(selectedBuilding, 'address.addressLine1');
        const addressLine2 = _.get(selectedBuilding, 'address.addressLine2');
        const mobileQuote = isMobile || isTablet;
        return (
            <>
                <div>
                    <h5 className='building-details-card-building-name'>{name}</h5>
                    <h6 className='building-details-card-normal'>
                        {addressLine1} {', '}
                        {addressLine2}
                    </h6>
                    {mobileQuote && !expanded && (

                        <div className='building-details-card-column'>
                            <h6 className='building-details-card-normal'>Starting From</h6>
                            <p className='building-details-card-price'>R{getLowestStartingPrice()}</p>
                        </div>

                    )}

                    {!mobileQuote && (
                        <div className='building-details-card-first-container'>

                            <div className='building-details-card-row'>
                                <h6 className='building-details-card-bold'>Availability</h6>
                                <h6 className='building-details-card-normal'>{getTotalAvailable()} spaces available</h6>
                            </div>

                            <div className='building-details-card-row'>
                                <h6 className='building-details-card-bold'>Booking From</h6>
                                <h6 className='building-details-card-normal'> {getSoonestAvailable()}</h6>
                            </div>

                        </div>
                    )}
                </div>
            </>
        );
    };

    const QuoteButtons = () => {
        let buttonText = 'Find a Space';
        if ((isMobile || isTablet) && !expanded) {
            buttonText = 'Continue';
        }

        return (
            <div className='building-details-card-quote-input-container'>
                <Button
                    className='building-details-card-book-button'                    
                    id="find-a-space-card-button"
                    onClick={
                        (isMobile || isTablet) && !expanded ? onContinueClick : onFindaSpaceClick
                    }
                >
                    {buttonText}
                </Button>
            </div>
        );
    };

    const mobileQuote = isMobile || isTablet;
    return (
        <>
            {mobileQuote && (

                <div className='building-details-card-mobile-container'>

                    <CardHeader />

                    <Accordion
                        className='building-details-card-accordion'                        
                        expanded={expanded}
                        onChange={handleExpansionChange}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandLess />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className='building-details-card-expansion-summary'
                        />

                        <AccordionDetails className='building-details-card-panel-details'>

                            <div className='building-details-card-mobile-scroll'>

                                <hr className='building-details-card-divider' />

                                <div className='building-details-card-first-container-mobile'>

                                    <div className='building-details-card-row'>
                                        <h6 className='building-details-card-bold'>Availability</h6>
                                        <h6 className='building-details-card-normal'>
                                            {getTotalAvailable()} spaces available
                                        </h6>
                                    </div>

                                    <div className='building-details-card-row'>
                                        <h6 className='building-details-card-bold'>Booking From</h6>
                                        <h6 className='building-details-card-normal'> {getSoonestAvailable()}</h6>
                                    </div>

                                </div>

                                <hr className='building-details-card-divider' />

                                <h6 className='building-details-card-bold'>Available Room Types</h6>

                                {getCategoriesMobile()}

                                <hr className='building-details-card-divider' />

                            </div>

                            <div className='building-details-card-column'>
                                <h6 className='building-details-card-normal'>Starting From</h6>
                                <p className='building-details-card-price'>R{getLowestStartingPrice()}</p>
                            </div>

                        </AccordionDetails>

                    </Accordion>

                    <QuoteButtons />

                </div>

            )}

            {!mobileQuote && (

                <div className='building-details-card-quote-card' id="booking-quote-container">

                    <CardHeader />

                    <hr className='building-details-card-divider' />

                    <h6 className='building-details-card-bold'>Available Room Types</h6>

                    {getCategories()}

                    <hr className='building-details-card-divider' />

                    <div className='building-details-card-column'>
                        <h6 className='building-details-card-normal'>Starting From</h6>
                        <p className='building-details-card-price'>R{getLowestStartingPrice()}</p>
                    </div>

                    <QuoteButtons />

                </div>
            )}
        </>
    );
};

export default BuildingDetailsCard;

BuildingDetailsCard.propTypes = {
    selectedBuilding: PropTypes.object,
    selectedBuildingRoomTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    cities: PropTypes.object,
    selectedBuildingRoomTypesSummary: PropTypes.array,
};

